import React, { useState } from 'react'

import { API } from '../../../revelry_api'
import { VeteranContactFormValues } from '../../../types'
import EventTrackingModel from '../../models/EventTrackingModel'
import VeteranContactForm from '../../../forms/VeteranContactForm'
import styles from './styles.module.scss'

type SubmissionStatus = 'idle' | 'success' | 'error'

const VeteranContactSection: React.FC = () => {
  const [submissionStatus, setSubmissionStatus] = useState<SubmissionStatus>('idle')
  const [errorMessage, setErrorMessage] = useState<string>('')

  const handleSubmit = async (values: VeteranContactFormValues): Promise<void> => {
    try {
      setErrorMessage('')
      await API.veteranContact.submit(values)
      setSubmissionStatus('success')
      if (values.howCanWeHelp === 'Arlington National Cemetery Services') {
        EventTrackingModel.trackArlingtonCemeteryInquiry()
      } else {
        EventTrackingModel.trackGeneralVeteranServicesInquiry()
      }
    } catch (error) {
      const message =
        error instanceof Error ? error.message : 'Something went wrong. Please try again.'
      setErrorMessage(message)
      setSubmissionStatus('error')
    }
  }

  const handleReset = (): void => {
    setSubmissionStatus('idle')
    setErrorMessage('')
  }

  return (
    <section id="contact-form" className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.heading}>
          We&apos;re Here To Guide You Every
          <br />
          Step of the Way
        </h2>
        <p className={styles.subtitleLine1}>
          Ready to learn more about our veteran services?
          <br />
          Fill out the form below and a member of our team will be in touch.
        </p>

        {submissionStatus === 'success' ? (
          <div className={styles.successMessage}>
            <h3 className={styles.successHeading}>Thank You</h3>
            <p className={styles.successBody}>
              Your message has been received. A member of our team will contact you shortly to
              discuss how we can help honor your loved one&apos;s service.
            </p>
            <button className={styles.resetButton} onClick={handleReset} type="button">
              Submit Another Inquiry
            </button>
          </div>
        ) : (
          <VeteranContactForm
            onSubmit={handleSubmit}
            onStart={() => EventTrackingModel.trackVeteranFormStart()}
            errorMessage={submissionStatus === 'error' ? errorMessage : undefined}
          />
        )}
      </div>
    </section>
  )
}

export default VeteranContactSection
